import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconGiroCard: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"giro-card"} maskId="square-filled-radius-0-stroke-1-IconGiroCard"><path fillRule="evenodd" clipRule="evenodd" d="M2 4H22V20H2V4ZM9 9H6V10H9V9Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconGiroCard;
